import { createFileRoute } from '@tanstack/react-router'

import { InteractionPage } from '@/components/interactions/interaction-page'
import { useFollowClient } from '@/lib/current-client'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/clients/$clientId_/echanges/$interactionId')({
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  component: InteractionRoute,
})

function InteractionRoute() {
  const { clientId, interactionId } = Route.useParams()
  useFollowClient(clientId)
  // La page change avec l'échange : aucun état ne survit d'un échange à l'autre.
  return <InteractionPage key={interactionId} clientId={clientId} interactionId={interactionId} />
}
